import HttpRequest from './HttpRequest';

export default class CityService extends HttpRequest {
  static endpoint = 'cities';

  static async getAll() {
    this.endpoint = 'cities?is_available=false';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'cities';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'cities';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'cities';
    const response = await this.put(id, data);
    return response;
  }
}
